<template>
    <div
        v-if="steps.length"
        class="progress-steps-wrapper"
        :class="[{ 'has--no-sides': disableEnds }, color]"
    >
        <span
            v-for="(step, index) in steps"
            :key="index"
            class="progress-label"
            :class="{
                'is-complete': index < active,
                'is--click-enabled': enableStepClick[index],
                'is-active': index == active,
            }"
            :role="enableStepClick[index] && index < active ? 'button' : null"
            :style="labelPos(index)"
            @click.prevent="
                enableStepClick[index] && index < active
                    ? handleStepClick(index, step)
                    : null
            "
        >
            <span class="progress-label-item">{{ step }}</span>
            <span class="progress-label-marker" aria-hidden="true"></span>
        </span>
        <span
            class="progress-steps"
            :aria-valuenow="active"
            aria-valuemin="1"
            :aria-valuemax="steps.length"
            :style="progressStyle"
            role="progressbar"
            ref="stepsbar"
        ></span>
    </div>
</template>

<script>
export default {
    name: "Steps",
    props: {
        active: {
            type: Number,
            default: 0,
        },
        enableStepClick: {
            type: Array,
            default: () => [],
        },
        disableEnds: {
            type: Boolean,
            default: false,
        },
        steps: {
            type: Array,
            required: true,
        },
        color: {
            type: String,
            default: "",
        },
    },
    mounted() {
        // Trick Vue to trigger a simple CSS transition
        setTimeout(() => {
            if (this.$refs.stepsbar)
                this.$refs.stepsbar.classList.add("is-active");
        }, 0);
    },
    methods: {
        handleStepClick(index, step) {
            this.$emit("stepClick", index, step);
        },
        labelPos(index) {
            return "left:" + (index / (this.steps.length - 1)) * 100 + "%;";
        },
    },
    computed: {
        progressStyle() {
            return "--progress-percentage:" + this.percentage;
        },
        percentage() {
            return (this.active / (this.steps.length - 1)) * 100;
        },
    },
};
</script>
